import { render, staticRenderFns } from "./GiftUniqueCode.vue?vue&type=template&id=cfcd3852&scoped=true&"
import script from "./GiftUniqueCode.vue?vue&type=script&lang=js&"
export * from "./GiftUniqueCode.vue?vue&type=script&lang=js&"
import style0 from "./GiftUniqueCode.vue?vue&type=style&index=0&id=cfcd3852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcd3852",
  null
  
)

export default component.exports